// Import of the 12 Mercadini food parameters from ONE food sheet (no averaging between sheets). Plain module with no
// imports: it also runs under node (see foodSheetImport.test.mjs).

export const FOOD_PARAM_KEYS = [
  'food_sweetness', 'food_sweet_tendency', 'food_fatness', 'food_unctuousness', 'food_succulence', 'food_sapidity',
  'food_bitter_tendency', 'food_acid_tendency', 'food_aromaticity', 'food_spiciness', 'food_persistence', 'food_structure',
];

// Filled in = a number (0 included); null/undefined/''/non numeric = not filled in
export const isFilled = (value) => value !== null && value !== undefined && value !== '' && Number.isFinite(Number(value));

const clamp = (v) => Math.max(0, Math.min(10, Math.round(Number(v))));

// sheet: API food-sheet object (flattened `food_*` keys). Returns the 12 parameters: the number given by the sheet, or
// null where the sheet did not fill the parameter in. Used by "Import" (replaces every parameter of the form).
export function replaceFoodValues(sheet) {
  const out = {};
  FOOD_PARAM_KEYS.forEach((key) => { out[key] = sheet && isFilled(sheet[key]) ? clamp(sheet[key]) : null; });
  return out;
}

// "Complete empty values": only the parameters that are empty in `current` take the value of the sheet (when the sheet has
// one); a value already filled in, 0 included, is never overwritten. Returns { values: <the 12 parameters>, filled: [keys completed] }.
export function completeFoodValues(current, sheet) {
  const out = {};
  const filled = [];
  FOOD_PARAM_KEYS.forEach((key) => {
    if (current && isFilled(current[key])) out[key] = clamp(current[key]);
    else if (sheet && isFilled(sheet[key])) { out[key] = clamp(sheet[key]); filled.push(key); }
    else out[key] = null;
  });
  return { values: out, filled };
}

export const emptyFoodKeys = (values) => FOOD_PARAM_KEYS.filter((key) => !isFilled(values && values[key]));
